import DocumentViewerModal from "components/DocumentViewer";
import { Complaints, CouncilLitigation } from "types";

interface AppealProps {
  complaintData: Complaints;
  councilVerdict: CouncilLitigation[];
  onAppealRefresh: any;
}

export default function CouncilVerdictCard({
  complaintData,
  councilVerdict,
  onAppealRefresh,
}: AppealProps) {
  return (
    <div className="space-y-4">
      {councilVerdict?.map((obj) => {
        const docs = (obj?.council_decision_documents as any[]) || [];
        const sortedDocs = [...docs].sort(
          (a, b) =>
            new Date(b?.created_at ?? "").getTime() -
            new Date(a?.created_at ?? "").getTime()
        );
        const latestDoc = sortedDocs[0];
        const historyDocs = sortedDocs.slice(1);

        return (
          <div
            key={obj?.id}
            className="bg-white shadow-md rounded-xl p-4 w-full border-l-8 border-black mx-auto"
          >
            {/* Summary */}
            <div className="my-3">
              <p className="text-[#002855] font-medium">
                Council Decision Summary
              </p>
              <p className="text-gray-700 mt-1">
                {obj?.council_decision_summary || "-"}
              </p>
            </div>

            {/* Decision Documents: Latest and History */}
            {(latestDoc || historyDocs.length > 0) && (
              <div className="my-3">
                <h3 className="text-sm font-semibold text-gray-800 mb-2">
                  Council Decision Documents
                </h3>
                {latestDoc && (
                  <div className="mb-4">
                    <h4 className="text-xs font-semibold text-gray-600 mb-1">
                      Latest
                    </h4>
                    <DocumentViewerModal
                      documents={[latestDoc] as any}
                      baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/litigation-counciloffice-documents/document`}
                      layout="list"
                    />
                  </div>
                )}
                {historyDocs.length > 0 && (
                  <div>
                    <h4 className="text-xs font-semibold text-gray-600 mb-1">
                      History
                    </h4>
                    <DocumentViewerModal
                      documents={historyDocs as any}
                      baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/litigation-counciloffice-documents/document`}
                      layout="list"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Details */}
            <div className="mb-6">
              {obj?.accused_prosecutor_name && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="text-gray-600">Accused Prosecutor</p>
                  <p className="text-black font-medium">
                    {obj?.accused_prosecutor_name}
                  </p>
                </div>
              )}
              {obj?.council_decision_type && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="text-gray-600">Decision Type</p>
                  <p className="text-black font-medium">
                    {obj?.council_decision_type}
                  </p>
                </div>
              )}
              {obj?.discipline_measure_type && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="text-gray-600">Discipline Measure</p>
                  <p className="text-black font-medium">
                    {obj?.discipline_measure_type}
                  </p>
                </div>
              )}
              {obj?.council_decision_day && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="text-gray-600">Decision Day</p>
                  <p className="text-black font-medium">
                    {obj?.council_decision_day}
                  </p>
                </div>
              )}
              {typeof obj?.is_final_verdict_given === "boolean" && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="text-gray-600">Final Verdict</p>
                  <p className="text-black font-medium">
                    {obj?.is_final_verdict_given ? "Given" : "Not Given"}
                  </p>
                </div>
              )}
              {obj?.remaining_days_for_appeal !== null &&
                obj?.remaining_days_for_appeal !== undefined && (
                  <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                    <p className="text-gray-600">Remaining Days for Appeal</p>
                    <p className="text-black font-medium">
                      {obj?.remaining_days_for_appeal}
                    </p>
                  </div>
                )}
              {obj?.response_from_general_council && (
                <div className="my-3">
                  <p className="text-gray-600">Response from General Council</p>
                  <p className="text-gray-700 mt-1">
                    {obj?.response_from_general_council}
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
